import template from './contactsCampaignMonitorEmbed.template.html';

export default {
  bindings: {
    onClosed: '&'
  },
  controller: class controller {
    constructor($sce, $mdDialog, $mdMedia, campaignMonitorService, uiService) {
      'ngInject';

      const ctrl = this;
      ctrl.$mdMedia = $mdMedia;
      ctrl.currentOrganization = null;

      ctrl.initialize = () => {
        uiService.toast({
          text: {
            p1: 'Authenticating with',
            p2: 'campaignMonitor',
            p3: ', please wait'
          },
          progress: true
        });
        campaignMonitorService.sso().then((res) => {
          if (res && res.SessionUrl) {
            $mdDialog
              .show({
                locals: {
                  source: res.SessionUrl
                },
                template,
                controllerAs: '$ctrl',
                controller(scope, source) {
                  const self = this;
                  self.src = () => $sce.trustAsResourceUrl(source);

                  self.cancel = () => {
                    ctrl.onClosed();
                    $mdDialog.cancel();
                  };
                }
              })
              .then(() => {});
          } else {
            uiService.toast({
              text: {
                p1: 'Failed to authenticate with',
                p2: 'campaignMonitor',
                p3: ', check your Integration'
              },
              warn: true
            });
          }
        });
      };

      ctrl.$onInit = () => {
        ctrl.initialize();
      };
    }
  }
};
